<template>
    <div class="book">
        <div
            v-if="bookName"
            class="locomash-book-header"
            v-bind:style="{backgroundImage: 'url(' + require(`@/assets/frame_${bookName.toLowerCase()}.jpg`) +')', }"
            style="position: fixed; width: 100%; top: 0; z-index: 100;"
        >
            <b-container>
                <b-row>
                    <b-col lg="6" class="d-none d-xl-block d-lg-block d-xl-none">
                        <router-link to="/">
                            <img
                                src="@/assets/img/locomash_logo_main.svg"
                                class="locomash-logo"
                                style="margin: 15px 0"
                            />
                        </router-link>
                    </b-col>
                    <b-col
                        lg="2"
                        cols="4"
                        offset-lg="4"
                        offset="8"
                        style="padding-top:25px;"
                        v-if="bookName"
                    >
                        <b-form-select
                            :options="
                                Books.filter(
                                    v => v.name === bookName.toLowerCase()
                                )[0].pages
                            "
                            v-model="bookPage"
                            @input="ScrollToImage"
                        ></b-form-select>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div style="margin-top: 100px;">
            <div class="d-xl-none d-lg-none">
                <b-col cols="12">
                    <router-link to="/">
                        <img
                            src="@/assets/img/locomash_logo_main.svg"
                            class="locomash-logo"
                            style="width: 55%;"
                        />
                    </router-link>
                </b-col>
            </div>
        </div>
        <div v-if="bookName" class="locomash-book-pages" style="margin-top: 30px;">
            <gallery
                v-if="index !== null"
                @onOpened="closeGallery($event)"
                :images="GenerateImagesArray()"
                :startAt="index"
            ></gallery>

            <b-container
                v-for="(pages, index) in Books.filter(
                    v => v.name === bookName.toLowerCase()
                )[0].pages"
                :key="index"
                :id="pages"
            >
                <b-row>
                    <div class="locomash-book-page-indicator">
                        <p style="margin: 0">{{ pages }}</p>
                    </div>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="12" style="padding: 0">
                        <b-img
                            :src="
                                require(`@/assets/Books/${bookName.toUpperCase()}/${pages.toUpperCase()}.jpg`)
                            "
                            style="width: 100%"
                            @click="setIndexForGallery(index)"
                        ></b-img>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
var VueScrollTo = require('vue-scrollto')
import LigthBox from '@/components/Ligthbox'

export default {
    components: {
        gallery: LigthBox,
    },
    data() {
        return {
            index: null,
            bookName: '',
            bookPage: '',
            Books: [
                {
                    name: 'freelance',
                    pages: [
                        '01',
                        '02',
                        '03',
                        '04',
                        'LOGOS_01',
                        'LOGOS_02',
                        'LOGOS_03',
                        'branding01_og',
                        'branding02_vesta',
                        'branding03_heavy',
                    ],
                },
                {
                    name: 'spark',
                    pages: ['soon'],
                },
                {
                    name: 'otros',
                    pages: [
                        '000-001',
                        '002-003',
                        '004-005',
                        '006-007',
                        '008-009',
                        '010-011',
                        '012-013',
                        '014-015',
                        '016-017',
                        '018-019',
                        '020-021',
                        '022-023',
                        '024-025',
                        '026-027',
                        '028-029',
                        '030-031',
                        '032-033',
                        '034-035',
                        '036-037',
                        '038-039',
                        '040-041',
                        '042-043',
                    ],
                },
                {
                    name: 'random',
                    pages: [
                        'CH00-000-001',
                        'CH00-002-003',
                        'CH00-004-005',
                        'CH00-006-007',
                        'CH01-008-009',
                        'CH01-010-011',
                        'CH01-012-013',
                        'CH01-014-015',
                        'CH01-016-017',
                        'CH01-018-019',
                        'CH01-020-021',
                        'CH01-022-023',
                        'CH01-024-025',
                        'CH01-026-027',
                        'CH01-028-029',
                        'CH01-030-031',
                        'CH01-032-033',
                        'CH01-034-035',
                        'CH01-036-037',
                        'CH01-038-039',
                        'CH01-040-041',
                        'CH01-042-043',
                        'CH01-044-045',
                        'CH01-046-047',
                        'CH01-048-049',
                    ],
                },
            ],
        }
    },
    async mounted() {
        this.bookName = this.$route.params.bookName
        this.bookPage = this.$route.params.bookPage
            ? this.Books.filter(v => v.name === this.bookName.toLowerCase())[0]
                  .pages[this.$route.params.bookPage]
            : null
        window.addEventListener('load', event => {
            VueScrollTo.scrollTo(document.getElementById(this.bookPage))
        })
    },
    methods: {
        closeGallery(event) {
            if (!event) {
                this.index = null
                document.removeEventListener('keydown', this.addKeyEvent)
                document.querySelector('html').classList.remove('no-scroll')
                document.querySelector('body').classList.remove('vue-lb-open')
            }
        },
        ScrollToImage(selected) {
            let list = this.Books.filter(
                v => v.name === this.bookName.toLowerCase()
            )[0].pages
            this.$router.push(`/${this.bookName}/${list.indexOf(selected)}`)
            VueScrollTo.scrollTo(document.getElementById(selected))
        },
        GenerateImagesArray() {
            let array = []
            let pages = this.Books.filter(
                v => v.name === this.bookName.toLowerCase()
            )[0].pages
            pages.forEach(element => {
                array.push({
                    src: require(`@/assets/Books/${this.bookName.toUpperCase()}/${element.toUpperCase()}.jpg`),
                })
            })
            return array
        },
        setIndexForGallery(imageIndex) {
            document.addEventListener('keydown', this.addKeyEvent)
            this.index = imageIndex
            console.log(this.$refs.ligthBox)
        },
    },
}
</script>

